import { render, staticRenderFns } from "./TrainingRecDialog.vue?vue&type=template&id=3b0c011b&scoped=true&"
import script from "./TrainingRecDialog.vue?vue&type=script&lang=js&"
export * from "./TrainingRecDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0c011b",
  null
  
)

export default component.exports